import axios, { endpoints } from 'src/utils/axios';

export const ChangePassword = async (data) => {
  const response = await axios.post('/api/User/changePassword', data);
  return response;
};

export const ResetPassword = async () => {
  const response = await axios.patch('/api/User/resetPassword');
  return response;
};

export const ResetPasswordByAdmin = async (userId) => {
  const url = endpoints.auth.resetPasswordByAdmin.replace('{userId}', userId);
  const response = await axios.post(url);
  return response;
};

export const GetUser = async () => {
  const response = await axios.get('/api/User/profile');
  return response;
};

export const GetUserById = async (userId) => {
  try{
    const response = await axios.get(`/api/User/${userId}`);
    return response;
  }catch(err){
    console.log(err)
    return null;
  }
};

export const CreateUser = async (data) => {
  const response = await axios.post('/api/User', data);
  return response;
};

export const UpdateUser = async (id, data) => {
  const response = await axios.put(`/api/User/profile${id}`, data);
  return response;
};

export const getAllUsers = async () => {
  const response = await axios.get('/api/User');
  return response;
};

export const DeleteUser = async (id) => {
  const response = await axios.delete(`/api/User/${id}`);
  return response;
};

export const EnableDesableUser = async (id) => {
  const response = await axios.put(`/api/User/EnableDesableUser${id}`);
  return response;
};
